'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  margin-bottom: 5px;\n  margin-top: 28px;\n  padding: 0;\n\n  input {\n    width: 100%;\n    background: transparent;\n    border: none;\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n    border-bottom-color: ', ';\n    border-radius: 0;\n    box-shadow: none;\n    padding: 10px 13px 3px 13px;\n    font-family: IntroRegular;\n    font-size: 16px;\n    color: #3e2723;\n  }\n\n  .show, input:focus + label {\n    top: -12px;\n    font-size: 10.5px;\n  }\n\n  input:focus + label {\n    color: ', ';\n  }\n\n  .show {\n    color: ', ';\n    font-family: ', ';\n  }\n\n  input:focus {\n    border-bottom-color: ', ';\n  }\n\n  .label-error-span {\n      color: #CD2028;\n      font-weight: 400;\n      text-transform: none;\n    }\n'], ['\n  position: relative;\n  margin-bottom: 5px;\n  margin-top: 28px;\n  padding: 0;\n\n  input {\n    width: 100%;\n    background: transparent;\n    border: none;\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n    border-bottom-color: ', ';\n    border-radius: 0;\n    box-shadow: none;\n    padding: 10px 13px 3px 13px;\n    font-family: IntroRegular;\n    font-size: 16px;\n    color: #3e2723;\n  }\n\n  .show, input:focus + label {\n    top: -12px;\n    font-size: 10.5px;\n  }\n\n  input:focus + label {\n    color: ', ';\n  }\n\n  .show {\n    color: ', ';\n    font-family: ', ';\n  }\n\n  input:focus {\n    border-bottom-color: ', ';\n  }\n\n  .label-error-span {\n      color: #CD2028;\n      font-weight: 400;\n      text-transform: none;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    position: absolute;\n    left: 13px;\n    top: 13px;\n    font-size: 14px;\n    color: #bcaaa3;\n    transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);\n    font-weight: bold;\n    text-transform: capitalize;\n    letter-spacing: 1px;\n'], ['\n    position: absolute;\n    left: 13px;\n    top: 13px;\n    font-size: 14px;\n    color: #bcaaa3;\n    transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);\n    font-weight: bold;\n    text-transform: capitalize;\n    letter-spacing: 1px;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n    display: ', ';\n    text-transform: capitalize;\n    color: #CD2028;\n    font-family: IntroRegular;\n'], ['\n    display: ', ';\n    text-transform: capitalize;\n    color: #CD2028;\n    font-family: IntroRegular;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var TextFieldStyled = _styledComponents2.default.div(_templateObject, function (props) {
    return props.error ? '#CD2028' : '#bcaaa3';
}, function (props) {
    return props.error ? '#CD2028' : '#04A2DC';
}, function (props) {
    return props.error ? '#CD2028' : '#BCAAA3';
}, function (props) {
    return props.error ? 'IntroBold' : 'inherit';
}, function (props) {
    return props.error ? '#CD2028' : '#04A2DC';
});

var LabelStyled = _styledComponents2.default.label(_templateObject2);

var ErrorSpanStyled = _styledComponents2.default.span(_templateObject3, function (props) {
    return props.show ? 'inline' : 'none';
});

var TextField = function (_React$Component) {
    _inherits(TextField, _React$Component);

    function TextField(props) {
        _classCallCheck(this, TextField);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this.state = {
            value: props.value,
            error: props.error,
            isPopulated: !!props.value
        };
        return _this;
    }

    TextField.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var newState = {};
        if (nextProps.value !== this.state.value) {
            newState.value = nextProps.value;
        }
        if (nextProps.error !== this.state.error) {
            newState.error = nextProps.error;
        }
        this.setState(newState);
    };

    TextField.prototype.onChange = function onChange(e) {
        var value = e.target.value;

        this.setState({ value: value, isPopulated: !this.state.isPopulated ? true : this.state.isPopulated }, this.props.onChangeHandler(value));
    };

    TextField.prototype.formatId = function formatId() {
        return this.props.label.toLowerCase().replace(' ', '_');
    };

    TextField.prototype.render = function render() {
        var _this2 = this;

        var show = this.state.isPopulated || !!this.state.value || !!this.state.error ? 'show' : '';
        var errorState = !!this.state.error;

        return _react2.default.createElement(
            TextFieldStyled,
            { className: 'custom-input-field', error: errorState },
            _react2.default.createElement('input', _extends({ readOnly: this.props.readOnly,
                id: this.formatId() + '_input',
                required: this.props.required,
                onChange: function onChange(e) {
                    return _this2.onChange(e);
                },
                onBlur: this.props.validate,
                type: this.props.type,
                value: this.state.value
            }, this.props.inputAttributes)),
            _react2.default.createElement(
                LabelStyled,
                { className: show,
                    htmlFor: this.formatId() + '_input' },
                this.props.label + ' ',
                _react2.default.createElement(
                    ErrorSpanStyled,
                    { show: errorState },
                    this.state.error
                )
            )
        );
    };

    return TextField;
}(_react2.default.Component);

TextField.propTypes = {
    onChangeHandler: _propTypes2.default.func,
    validate: _propTypes2.default.func,
    readOnly: _propTypes2.default.bool,
    required: _propTypes2.default.bool,
    label: _propTypes2.default.string,
    value: _propTypes2.default.string,
    type: _propTypes2.default.string,
    error: _propTypes2.default.string,
    inputAttributes: _propTypes2.default.shape({})
};

TextField.defaultProps = {
    onChangeHandler: function onChangeHandler() {},
    validate: function validate() {},
    readOnly: false,
    required: false,
    label: '',
    value: '',
    type: 'text',
    error: '',
    inputAttributes: {}
};

exports.default = TextField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/TextField/index.js
// module id = 207
// module chunks = 0